var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExistingCustomerSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.828125,18H21c1.6542969,0,3-1.3457031,3-3V5c0-1.6542969-1.3457031-3-3-3H3C1.3457031,2,0,3.3457031,0,5v10 c0,1.6542969,1.3457031,3,3,3l2-0.0019531v3.5878906C5,22.9169922,6.0830078,24,7.4140625,24 c0.6357422,0,1.2578125-0.2578125,1.7070312-0.7070312l5-5C14.3076172,18.1064453,14.5654297,18,14.828125,18z  M7.7070312,21.8789062C7.46875,22.1171875,7,21.9238281,7,21.5859375V18c0-1.1025391-0.8974609-2-2-2H3 c-0.5517578,0-1-0.4482422-1-1V5c0-0.5517578,0.4482422-1,1-1h18c0.5517578,0,1,0.4482422,1,1v10c0,0.5517578-0.4482422,1-1,1 h-6.171875c-0.8007812,0-1.5546875,0.3125-2.1210938,0.8789062L7.7070312,21.8789062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,8h-3v2h3c0.5517578,0,1,0.4482422,1,1v10c0,0.5517578-0.4482422,1-1,1h-2c-1.1025391,0-2,0.8974609-2,2v3.5859375 c0,0.3378906-0.4677734,0.5322266-0.7070312,0.2929688l-5-5C18.7265625,22.3125,17.9726562,22,17.171875,22H13v2h4.171875 c0.2626953,0,0.5205078,0.1064453,0.7070312,0.2929688l5,5C23.328125,29.7421875,23.9501953,30,24.5859375,30 C25.9169922,30,27,28.9169922,27,27.5859375V24h2c1.6542969,0,3-1.3457031,3-3V11C32,9.3457031,30.6542969,8,29,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingCustomerSmall);
export default __webpack_public_path__ + "static/media/existing-customer--small.29851af2b1289832c38e7164c812e1d0.svg";
export { ForwardRef as ReactComponent };